import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata";


function Wellness() {

  return (
    <>
      <section>
          <div className="container px-4 md:px-6">
            <h2>Your wellbeing is important to us!</h2>
            <p>5WCWS is so excited to be building our wellness program for 5WCWS. We look forward to providing spaces, opportunities and activities for all our delegates to access self-care and have an amazing and energising Conference!</p>
            <p>As we refine our plans, we will update the details.</p>
            <p>We cannot wait to share what will be on offer.</p>
          </div>
      </section>
    </>
  )
}

export default Wellness

export function Head() {
  const { title } = useSiteMetadata();
  return (
    <>
      <title>{`Wellness - ${title}`}</title>
      <meta name="description" content="Explore wellness topics at the 5th World Conference of Women's Shelters 2025. Learn about the role of wellness in supporting survivors and enhancing shelter services." />
      <meta name="keywords" content="5WCWS, WCWS, Women's Shelters, World Conference, 2025, wellness, survivor support, shelter services, holistic health, self-care" />
    </>
  )
}
